import {
  COACH_COMPONENT_TEMPLATES_LIBRARY_ARCHIVED_ROUTE,
  COACH_COMPONENT_TEMPLATES_LIBRARY_PUBLISHED_ROUTE,
} from "../../routes/routes";

export const componentTemplateLibraryNavigation = [
  {
    name: "Published",
    link: COACH_COMPONENT_TEMPLATES_LIBRARY_PUBLISHED_ROUTE,
  },

  {
    name: "Archived",
    link: COACH_COMPONENT_TEMPLATES_LIBRARY_ARCHIVED_ROUTE,
  },
];
